import { Service, Slide, Stat, ContactInfo, NavItem } from '../types';

// 导航配置
export const NAV_ITEMS: NavItem[] = [
  { path: '/', label: '网站首页', icon: 'home' },
  { path: '/about', label: '公司简介', icon: 'building' },
  { 
    path: '/services', 
    label: '产品中心', 
    icon: 'cogs',
    children: [
      { path: '/services/service', label: '消防服务' },
      { path: '/services/equipment', label: '消防设备' }
    ]
  },
  { path: '/cases', label: '客户案例', icon: 'briefcase' },
  { path: '/answer', label: '消防咨询', icon: 'question-circle' },
  { path: '/contact', label: '联系我们', icon: 'envelope' },
];

// 轮播图数据
export const SLIDES: Slide[] = [
  { 
    id: 1, 
    image: '/images/banner-1.jpg', 
    alt: '消防电气检测 - 消防整体解决服务商' 
  },
  { 
    id: 2, 
    image: '/images/banner-2.jpg', 
    alt: '消防维保检测 各类灭火器检修' 
  },
];

// 服务项目数据
export const SERVICES: Service[] = [
  { 
    id: 1, 
    image: '/images/services-1.jpg', 
    title: '消电检测 消防维保', 
    alt: '消电检测 消防维保',
    description: '专业的消防电气检测服务，包括消防设施检测、维保、维修等全方位服务。'
  },
  { 
    id: 2, 
    image: '/images/services-2.jpg', 
    title: '各类灭火器检修', 
    alt: '各类灭火器检修',
    description: '提供各类灭火器的销售、检修、充装、维修等专业服务。'
  },
  { 
    id: 3, 
    image: '/images/services-3.jpg', 
    title: '消防维修 查线', 
    alt: '消防维修 查线',
    description: '消防系统故障排查、线路检测、设备维修等专业技术服务。'
  },
  { 
    id: 4, 
    image: '/images/services-4.jpg', 
    title: '七氟丙烷钢瓶检修施工', 
    alt: '七氟丙烷钢瓶检修施工',
    description: '七氟丙烷气体灭火系统的安装、检修、充装、施工等专业服务。'
  },
  { 
    id: 5, 
    image: '/images/services-5.jpg', 
    title: '消防架批发 定制 设计', 
    alt: '消防架批发 定制 设计',
    description: '消防架、消防柜等设备的批发销售、定制设计、安装服务。'
  },
  { 
    id: 6, 
    image: '/images/services-6.jpg', 
    title: '消防产品批发 销售', 
    alt: '消防产品批发 销售',
    description: '各类消防设备、报警产品、安防产品的批发销售服务。'
  },
  { 
    id: 7, 
    image: '/images/services-7.jpg', 
    title: '消防工程验收 代办', 
    alt: '消防工程验收 代办',
    description: '消防工程验收、资质办理、建委许可咨询等代办服务。'
  },
  { 
    id: 8, 
    image: '/images/services-8.jpg', 
    title: '消防柜箱批发 定制 设计', 
    alt: '消防柜箱批发 定制 设计',
    description: '消防柜箱产品的批发销售、定制设计、安装维护服务。'
  }
];

// 统计数据
export const STATS: Stat[] = [
  { number: '1000+', label: '服务客户' },
  { number: '50+', label: '专业团队' },
  { number: '25+', label: '行业经验' },
];

// 联系信息
export const CONTACT_INFO: ContactInfo[] = [
  {
    type: 'emergency',
    icon: 'exclamation-triangle',
    title: '紧急服务',
    details: ['24小时应急响应热线', '186-0038-5876']
  },
  {
    type: 'office',
    icon: 'map-marker-alt',
    title: '总部地址',
    details: ['北京市通州区潞城镇胡郎路80号1051', '邮编：101100']
  },
  {
    type: 'online',
    icon: 'headset',
    title: '线上服务',
    details: ['841854015@qq.com', '微信客服：jdat119']
  }
];

// 消防设备数据
export const EQUIPMENT_DATA: Service[] = [
  {
    id: 1,
    image: '/images/fire-equipment/services-5.jpg',
    title: '消防架批发、定制、设计',
    alt: '消防架批发、定制、设计',
    description: '消防架产品的批发销售、定制设计、安装维护等专业服务。'
  },
  {
    id: 2,
    image: '/images/fire-equipment/services-8.jpg',
    title: '消防柜箱批发、定制、设计',
    alt: '消防柜箱批发、定制、设计',
    description: '消防柜箱产品的批发销售、定制设计、安装维护等专业服务。'
  }
];

// 消防服务数据
export const SERVICE_DATA: Service[] = [
  {
    id: 5,
    image: '/images/fire-services/electrical-fire-inspection.jpg',
    title: '消电检测、消防维保',
    alt: '消电检测、消防维保',
    description: '专业提供消防电气检测和消防维保服务，包括各类灭火器销售检修、消防维修查线、消防主机报警产品维修等全方位消防技术服务。'
  },
  {
    id: 6,
    image: '/images/fire-services/fire-extinguisher-inspection.jpg',
    title: '各类灭火器检修',
    alt: '各类灭火器检修',
    description: '各类灭火器检修、维修、充装服务，北京地区免费取送，正规资质。'
  },
  {
    id: 7,
    image: '/images/fire-services/fire-safety-inspection.jpg',
    title: '消防安全评估',
    alt: '消防安全评估',
    description: '专业的消防安全评估服务，包括消防系统、消防联动试验、住宅和商旅消防安全评估。'
  },
  {
    id: 8,
    image: '/images/fire-services/fire-equipment-maintenance.jpg',
    title: '消防维修查线',
    alt: '消防维修查线',
    description: '专业消防维修查线服务，维修消防系统故障，确保消防系统正常运行。'
  },
  {
    id: 9,
    image: '/images/fire-services/fire-equipment-recycling.jpg',
    title: '七氟丙烷钢瓶、灭火器回收',
    alt: '七氟丙烷钢瓶、灭火器回收',
    description: '七氟丙烷钢瓶、灭火器回收服务，环保处理，符合相关规定。'
  },
  {
    id: 10,
    image: '/images/fire-services/fire-safety-training.jpg',
    title: '消防安全培训',
    alt: '消防安全培训',
    description: '专业消防安全培训服务，提供消防知识培训和应急演练指导。'
  },
  {
    id: 11,
    image: '/images/fire-services/fire-suppression-cylinders.jpg',
    title: '七氟丙烷钢瓶检修施工',
    alt: '七氟丙烷钢瓶检修施工',
    description: '七氟丙烷钢瓶检修、施工、维护服务，专业技术人员现场施工。'
  },
];

// 公司配置
export const COMPANY_CONFIGS = {
  zhonghe: {
    name: '北京众合安诚消防技术有限公司',
    shortName: '众合安诚消防',
    description: '北京众合安诚消防技术有限公司为消防整体解决服务商，总部创建于2001年，至今已有25年发展历史，公司已通过ISO9001全面质量管理体系认证，具有完善的质量保证体系，A级信用企业，是全国消防重点骨干企业、北京消防协会会员单位。公司有专业灭火器维修车间，专业工程师会为广大客户提供消防检测、维保、消防安全评估、实时报价及消防系统整体解决方案。',
    description2: '我们公司专业从事建筑消防设施检测、消防安全评估、灭火器检修、建筑消防设施维护保养、消防设备安装维护、消防项目管理与专业咨询、消防安全咨询、电气防火安全检测、消防培训、消防设备销售与维修、七氟丙烷气体灭火系统检修与施工，消防主机、报警产品销售与维修、防雷检测等。'
  },
  jingdun: {
    name: '北京京盾安泰消防设备技术有限公司',
    shortName: '京盾安泰消防',
    description: '北京京盾安泰消防设备技术有限公司为消防整体解决服务商，总部创建于2001年，至今已有25年发展历史，公司已通过ISO9001全面质量管理体系认证，具有完善的质量保证体系，A级信用企业，是全国消防重点骨干企业、北京消防协会会员单位。公司有专业灭火器维修车间，专业工程师会为广大客户提供消防检测、维保、消防安全评估、实时报价及消防系统整体解决方案。',
    description2: '我们公司专业从事建筑消防设施检测、消防安全评估、灭火器检修、建筑消防设施维护保养、消防设备安装维护、消防项目管理与专业咨询、消防安全咨询、电气防火安全检测、消防培训、消防设备销售与维修、七氟丙烷气体灭火系统检修与施工，消防主机、报警产品销售与维修、防雷检测等。'
  }
};

// 当前激活的公司配置（可以在这里切换）
const ACTIVE_COMPANY: keyof typeof COMPANY_CONFIGS = 'zhonghe'; // 'zhonghe' 或 'jingdun'

// 公司信息（基于当前激活的配置）
export const COMPANY_INFO = COMPANY_CONFIGS[ACTIVE_COMPANY]; 